import datepickerTranslations from '../translations/datepicker';

const MONTH_INDEX_BY_NAME = {};
const indexMonthNames = (names = []) => {
  names.forEach((name, index) => {
    MONTH_INDEX_BY_NAME[name.toLowerCase()] = index;
  });
};
Object.values(datepickerTranslations).forEach(locale => {
  indexMonthNames(locale.monthsShort);
  indexMonthNames(locale.monthsFull);
});

const dateFormatParsers = {
  'dd-mmm-yy': stringDate => {
    const parts = stringDate.split('-');
    if (parts.length !== 3) return null;
    const [day, monthName, year] = parts;
    const monthIndex = MONTH_INDEX_BY_NAME[monthName.toLowerCase()];
    if (monthIndex === undefined) return null;
    return new Date(2000 + Number(year), monthIndex, Number(day));
  },
  'mmm-dd-yy': stringDate => {
    const parts = stringDate.split('-');
    if (parts.length !== 3) return null;
    const [monthName, day, year] = parts;
    const monthIndex = MONTH_INDEX_BY_NAME[monthName.toLowerCase()];
    if (monthIndex === undefined) return null;
    return new Date(2000 + Number(year), monthIndex, Number(day));
  },
  'yyyy-mm-dd': stringDate => {
    const [year, month, day] = stringDate.split('-');
    const monthIndex = Number(month) - 1;
    return new Date(year, monthIndex, day);
  },
};

export default function stringToDate(string, format = 'dd-mmm-yy') {
  const dateFormatParser = dateFormatParsers[format];
  if (!string || !dateFormatParser) return null;

  return dateFormatParser(string);
}
